import React, { Component } from 'react';
import { Field, FieldArray } from 'redux-form';
import { required, SelectInput } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

import Properties from './Properties';
import ConfirmDeleteIcon from '../../Buttons/ConfirmDeleteIcon';
import FetchData from '../../../Framework/Fetch';

const ValidateRequired = required();

type Props = {
  handlePropertyGroupRemove: any,
  item: string,
  propertyGroupIndex: number,
  propertyGroupOptions: any,
  propertyGroupRecords: any,
  record: any
};

type StateProps = {
  properties: string[],
  selectedPropertyGroupValue: string | boolean,
  showProperties: string
};

class PropertyGroup extends Component<Props, StateProps> {
  state = { properties: [], selectedPropertyGroupValue: null, showProperties: 'none' };

  componentDidMount() {
    if (
      this.props.propertyGroupRecords &&
      this.props.propertyGroupRecords[this.props.propertyGroupIndex]
    ) {
      const propertyGroups = this.props.propertyGroupRecords;
      const selectedPropertyGroupValue = propertyGroups[this.props.propertyGroupIndex].name;

      this.setState({ selectedPropertyGroupValue: selectedPropertyGroupValue });

      FetchData('/helpers/lookup_properties', {
        _end: 25, _order: 'DESC', _sort: 'updated_at', _start: 0, property_group_value: selectedPropertyGroupValue
      })
        .then(json => {
          this.setState({ properties: json, showProperties: 'initial' });
        });
    }
  }

  handlePropertyGroupChange = (e, index, value) => {
    const selectedPropertyGroup = this.props.propertyGroupOptions.find((propertyGroup) => propertyGroup.value === index);
    const selectedPropertyGroupValue = selectedPropertyGroup.value
    this.setState({ selectedPropertyGroupValue: selectedPropertyGroupValue })

    FetchData('/helpers/lookup_properties', {
      _end: 25, _order: 'DESC', _sort: 'updated_at', _start: 0, property_group_value: selectedPropertyGroupValue
    })
      .then(json => {
        this.setState({ properties: json, showProperties: 'initial' });
      });
  }

  render() {
    return (
      <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', padding: '5px 25px' }}>
        <div>
          {this.props.propertyGroupRecords && this.props.propertyGroupRecords[this.props.propertyGroupIndex] &&
            <div style={{ paddingTop: 5 }}>Property Group: {this.props.propertyGroupRecords[this.props.propertyGroupIndex].display_name}</div>
          }
          {this.props.propertyGroupRecords && !this.props.propertyGroupRecords[this.props.propertyGroupIndex] &&
            <Field
              choices={this.props.propertyGroupOptions}
              component={SelectInput}
              label="Name"
              name={`${this.props.item}.name`}
              onChange={(event, name, value) => this.handlePropertyGroupChange(event, name, value)}
              source={`${this.props.item}.name`}
              validate={ValidateRequired} />
          }
        </div><br />

        <div style={{ display: this.state.showProperties }}>
          <FieldArray
            addItemLabel="Add Property"
            component={Properties}
            mainLabel="Properties"
            name={`${this.props.item}.properties`}
            properties={this.state.properties}
            propertyGroupIndex={this.props.propertyGroupIndex}
            propertyGroupRecords={this.props.propertyGroupRecords}
            record={this.props.record}
            selectedPropertyGroupValue={this.state.selectedPropertyGroupValue} />
        </div>

        <div style={{ width: '100%', textAlign: 'right' }}>
          <ConfirmDeleteIcon onClick={(event) => this.props.handlePropertyGroupRemove(event, this.props.propertyGroupIndex)} />
        </div>
      </div>
    )
  }
};

export default PropertyGroup;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/PropertyGroups/PropertyGroup.tsx